
const newModel = () => {
    return {
        truongMamnonLophocId: null,
        truongMamnonId: null,
        tenTruongMamnon: null,
        idKy: null,
        tenKy: null,
        nhomTre: "0",
        lopMauGiao: "0",
        ghiChu: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        truongMamnonLophocId: null,
        truongMamnonId: null,
        idKy: null,
        nhomTre: "0",
        lopMauGiao: "0",
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        truongMamnonLophocId: item.truongMamnonLophocId,
        truongMamnonId: item.truongMamnonId,
        tenTruongMamnon: item.tenTruongMamnon,
        idKy: item.idKy,
        tenKy: item.tenKy,
        nhomTre: item.nhomTre,
        lopMauGiao: item.lopMauGiao,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongMamnonLophocId: item.truongMamnonLophocId,
        truongMamnonId: item.truongMamnonId,
        idKy: item.idKy,
        nhomTre: item.nhomTre,
        lopMauGiao: item.lopMauGiao,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        iocDateUpdated: item.iocDateUpdated,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongMamnonLophocId: null,
        truongMamnonId: null,
        tenTruongMamnon: null,
        idKy: null,
        tenKy: null,
        nhomTre: null,
        lopMauGiao: null,
        ghiChu: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

export const truongMamnonLophocModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


